module.exports = __webpack_public_path__ + "static/img/score-pc-5.1299da03.png";